module.exports = __webpack_public_path__ + "media/8bit.ae282b0b.wav";